import React from "react"

import { dispatch, subscribe } from "lib/events"
import { Button } from "packages/ui-shared/components/Button/Button"
import { useSegment } from "tracking"

import * as styles from "./YCSSModal.css"
import { YCSSPreference } from "./utils"
import type { MembershipOption } from "types"

type Props = {
  membership: Pick<MembershipOption, "savingsText" | "perks" | "terms">
}

export const YCSSModal: React.FC<Props> = ({ membership }) => {
  const headerRef = React.useRef<HTMLElement>(null)
  const [isOpen, setIsOpen] = React.useState(false)
  const [isDisabled, setIsDisabled] = React.useState(true)
  const { track } = useSegment()

  React.useEffect(() => {
    subscribe("ycss.open", () => {
      setIsOpen(true)
    })
    subscribe("ycss.close", () => {
      setIsOpen(false)
    })
  }, [])

  React.useEffect(() => {
    setIsDisabled(false)
  }, [])

  React.useEffect(() => {
    if (isOpen) {
      headerRef.current?.focus()
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "initial"
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  return (
    <div>
      {isOpen && (
        <div
          data-testid="YCSSModalBackDrop"
          className={styles.backdrop}
          onClick={() => setIsOpen(false)}
        ></div>
      )}
      <div className={isOpen ? styles.containerOpen : styles.container}>
        <div className={styles.wrapper} data-testid="ycss-modal">
          <header className={styles.header} tabIndex={-1} ref={headerRef}>
            <h2 className={styles.title}>You can still save</h2>
          </header>

          <div className={styles.body}>
            <p className={styles.highlighted}>{membership.savingsText}</p>

            <div className={styles.bodyContentWrapper}>
              <h3 className={styles.contentTitle}>
                Continue without a membership?
              </h3>

              {membership.perks && (
                <div
                  className={styles.bodyContent}
                  dangerouslySetInnerHTML={{
                    __html: membership.perks,
                  }}
                />
              )}

              {membership.terms.termsContent && (
                <p
                  className={styles.bodyContentFooter}
                  dangerouslySetInnerHTML={{
                    __html: membership.terms.termsContent,
                  }}
                />
              )}
            </div>
          </div>

          <div className={styles.footer}>
            <Button
              disabled={isDisabled}
              variant="primary"
              handleClick={() => {
                dispatch("ycss.preference", {
                  preference: YCSSPreference.WITH_MEMBERSHIP,
                })
                setIsOpen(false)

                track({
                  event: "Page Element Clicked",
                  properties: {
                    module_content: "Add beauty pie+ membership",
                  },
                })
              }}
            >
              Add product and join BeautyPie+
            </Button>

            <Button
              disabled={isDisabled}
              variant="link"
              handleClick={() => {
                dispatch("ycss.preference", {
                  preference: YCSSPreference.WITHOUT_MEMBERSHIP,
                })
                setIsOpen(false)

                track({
                  event: "Page Element Clicked",
                  properties: {
                    module_content: "Continue without membership",
                  },
                })
              }}
            >
              Continue without membership
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
